import { generateAuthHeader } from "../../commonfunctions/authentication";
import { IPaymentDetails } from "../../interfaces/interfaces";

export interface IPaymentDetailOptions {
  national: IPaymentDetails;
  international: IPaymentDetails;
}

export interface IPaymentSessionResponse {
  status: number;
  message: string | successPaymentStatus;
  payment_details_options: IPaymentDetailOptions | null;
  clientSecret: string;
}

export enum successPaymentStatus {
  "payment_confirmed" = "payment_confirmed",
  "payment_processing" = "payment_processing",
  "payment_requires_action" = "payment_requires_action",
  "ok" = "ok",
}

export const createPaymentIntent = async (orderId: string): Promise<IPaymentSessionResponse> => {
  const { headers } = generateAuthHeader();

  try {
    const res = await fetch(
      `${process.env.REACT_APP_HALFBACK_ROOT_API}/payment_intentions/create/${orderId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...headers,
        },
      },
    );
    const data: IPaymentSessionResponse = await res.json();
    return data;
  } catch (error) {
    const errorMessage: IPaymentSessionResponse = {
      status: 500,
      message: "Can't connect to Halfback API",
      payment_details_options: null,
      clientSecret: "",
    };

    return errorMessage;
  }
};

export const confirmPaymentIntent = async (
  orderId: string,
  paymentMethodId: string,
): Promise<IPaymentSessionResponse> => {
  const { headers } = generateAuthHeader();

  try {
    const res = await fetch(
      `${process.env.REACT_APP_HALFBACK_ROOT_API}/payment_intentions/confirm/${orderId}`,
      {
        method: "POST",
        body: JSON.stringify({ payment_method_id: paymentMethodId }),
        headers: {
          "Content-Type": "application/json",
          ...headers,
        },
      },
    );
    const data: IPaymentSessionResponse = await res.json();
    return data;
  } catch (error) {
    const errorMessage: IPaymentSessionResponse = {
      status: 500,
      message: "Can't connect to Halfback API",
      payment_details_options: null,
      clientSecret: "",
    };

    return errorMessage;
  }
};
